import { Button } from '@99designs/common/components/Button';
import { ButtonGroup, ButtonGroupItem } from '@99designs/common/components/ButtonGroup';
import { DesignerMeta_User } from '__generated__/DesignerMeta_User';
import Visible from 'common/components/Visible';
import { handlePromise } from 'common/utils/Bugsnag';
import DesignerMetaHeader from 'projects/components/DesignerMetaHeader';
import { Color } from 'projects/consts';
import { trackRemovedDesignerEvent } from 'projects/events';
import RemoveStructuredBriefDesigners from 'projects/mutations/RemoveStructuredBriefDesigners';
import React from 'react';
import ColorComponent from './Color';
import ConfirmationModal from './ConfirmationModal';

interface Props {
    brief: {
        id: string;
        designers: DesignerMeta_User[];
    };
    onConfirm: () => void;
    onDismiss: () => void;
    saving?: boolean;
    showing: boolean;
}

const DesignerConfirmationModal: React.SFC<Props> = ({
    brief,
    onConfirm,
    onDismiss,
    saving = false,
    showing,
}) => {
    const heading =
        brief.designers.length > 1 ? __('Confirm your designers') : __('Confirm your designer');

    return (
        <ConfirmationModal onDismiss={onDismiss} heading={heading} showing={showing}>
            <RemoveStructuredBriefDesigners>
                {removeDesigners => (
                    <div className="designer-meta-list">
                        {brief.designers.map(designer => (
                            <div className="designer-meta-list__item" key={designer.id}>
                                <DesignerMetaHeader
                                    designer={designer}
                                    onRemove={id => {
                                        trackRemovedDesignerEvent({
                                            id: brief.id,
                                            designer_id: designer.id,
                                        });
                                        handlePromise(
                                            removeDesigners({
                                                id: brief.id,
                                                designerIds: [id],
                                            }),
                                            'DesignerConfirmationModal RemoveDesigners'
                                        );
                                    }}
                                    paragraphSize={'regular'}
                                    avatarSize={'small'}
                                />
                            </div>
                        ))}
                    </div>
                )}
            </RemoveStructuredBriefDesigners>
            <div style={{ textAlign: 'right' }}>
                <ButtonGroup>
                    <ButtonGroupItem>
                        <a
                            type="button"
                            onClick={e => {
                                e.preventDefault();
                                return onDismiss();
                            }}
                            className="link link--back link--big-target"
                        >
                            {__('Back')}
                        </a>
                    </ButtonGroupItem>
                    <ButtonGroupItem>
                        <ColorComponent color={Color.createBlue}>
                            <Visible sizes={['small', 'medium']}>
                                <Button
                                    onClick={onConfirm}
                                    variations={['primary', 'chameleon']}
                                    isSaving={saving}
                                >
                                    {__('Confirm')}
                                </Button>
                            </Visible>
                            <Visible sizes={['normal', 'large']}>
                                <Button
                                    onClick={onConfirm}
                                    variations={['primary', 'jumbo', 'chameleon']}
                                    isSaving={saving}
                                >
                                    {__('Confirm')}
                                </Button>
                            </Visible>
                        </ColorComponent>
                    </ButtonGroupItem>
                </ButtonGroup>
            </div>
        </ConfirmationModal>
    );
};

export default DesignerConfirmationModal;
